import React from "react";
import BackgroundCard from "../../components/background-card";
import PasswordReset from "../../components/auth/reset-password";
import { useNavigate, useParams } from "react-router-dom";
import useRequest from "../../components/hooks/use-request";
import { useForm } from "react-hook-form";
import { showToast } from "../../components/toast";

const ResetPassword = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const userToken = localStorage.getItem("token");
  const { loading, makeRequest } = useRequest(
    `/auth/reset-password/${id}`,
    "POST",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );
  const { handleSubmit, control, reset, watch } = useForm();

  const handleResetPassword = handleSubmit(async (formData) => {
    const userReset = {
      password: formData.password,
    };
    const [response] = await makeRequest(userReset);
    if (response.status) {
      showToast(
        "A password reset link has been sent to your email address",
        true,
        {
          position: "top-center",
        }
      );
      reset();
      navigate("/signin");
    } else {
      showToast(response.message, false, {
        position: "top-center",
      });
    }
  });

  return (
    <>
      <BackgroundCard>
        <PasswordReset
          handleResetPassword={handleResetPassword}
          control={control}
          loading={loading}
          watch={watch}
        />
      </BackgroundCard>
    </>
  );
};

export default ResetPassword;
